<template>
  <div class="electric-field-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>详见下方原理说明</div>
    </div>

    <div class="canvas-box">
      <svg width="100%" height="400" viewBox="0 0 400 400">
        <!-- 电势等势面背景 (使用渐变模拟) -->
        <defs>
          <radialGradient id="potentialGradient">
            <stop offset="0%" :stop-color="chargeType > 0 ? 'rgba(255, 71, 87, 0.3)' : 'rgba(112, 161, 255, 0.3)'" />
            <stop offset="100%" stop-color="transparent" />
          </radialGradient>
        </defs>
        <circle cx="200" cy="200" r="180" fill="url(#potentialGradient)" />

        <!-- 电力线 -->
        <g v-for="angle in angles" :key="angle">
          <line
            :x1="200 + (chargeType > 0 ? 15 : 180) * Math.cos(angle)"
            :y1="200 + (chargeType > 0 ? 15 : 180) * Math.sin(angle)"
            :x2="200 + (chargeType > 0 ? 180 : 15) * Math.cos(angle)"
            :y2="200 + (chargeType > 0 ? 180 : 15) * Math.sin(angle)"
            stroke="#fff"
            stroke-width="1"
            opacity="0.4"
            marker-end="url(#arrow-field)"
          />
        </g>

        <!-- 电荷 -->
        <circle cx="200" cy="200" r="15" :fill="chargeType > 0 ? '#ff4757' : '#70a1ff'">
           <animate attributeName="r" values="14;16;14" dur="2s" repeatCount="indefinite" />
        </circle>
        <text x="200" y="206" text-anchor="middle" fill="#fff" font-size="16" font-weight="bold">
          {{ chargeType > 0 ? '+' : '-' }}
        </text>

        <defs>
          <marker id="arrow-field" markerWidth="8" markerHeight="6" refX="8" refY="3" orient="auto">
            <polygon points="0 0, 8 3, 0 6" fill="#fff" />
          </marker>
        </defs>
      </svg>
    </div>

    <div class="physics-text">
       <p>电场线越密，场强 E 越大。</p>
       <p>沿电场线方向，电势 φ 降低。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ElectricFieldViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      chargeType: 1,
      angles: Array.from({length: 12}, (_, i) => (i * 30 * Math.PI) / 180)
    }
  }
}
</script>

<style scoped lang="scss">
.electric-field-viz { width: 100%; color: #fff; display: flex; flex-direction: column; gap: 15px; }
.viz-header { display: flex; justify-content: space-between; padding: 10px; background: rgba(255,255,255,0.05); }
.canvas-box { background: #0a0a0a; border-radius: 8px; }
.physics-text { padding: 10px; font-size: 0.9rem; color: #888; border-left: 2px solid #00d2ff; }
</style>
